<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-tool">
                <a-button type="primary" icon="plus" @click="add">新增</a-button>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
                :defaultExpandAllRows="false"
                childrenColumnName="children"
            >
                <span slot="google" slot-scope="record" :class="record.googleBound ? 'normal' : 'disabled'">
                    {{ record.googleBound ? '已绑定' : '未绑定' }}
                </span>

                <span slot="status" slot-scope="record" :class="record.isEnable === 'Y' ? 'normal' : 'disabled'">
                    {{ record.isEnable === 'Y' ? '正常' : '停用' }}
                </span>

                <span slot="action" slot-scope="record">
                    <a @click="update(record)">修改</a>
                    <a-divider type="vertical" />
                    <a-dropdown>
                        <a>更多 <a-icon type="down" /></a>
                        <a-menu slot="overlay" @click="handleMore($event, record)">
                            <a-menu-item key="resetPassword">重置密码</a-menu-item>
                            <a-menu-item key="toggleEnable">
                                {{ record.isEnable === 'Y' ? '停用' : '启用' }}
                            </a-menu-item>
                            <a-menu-item key="google">
                                {{ record.googleBound ? '解绑谷歌验证' : '绑定谷歌验证' }}
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </span>
            </a-table>

            <div class="x-pagination">
                <a-pagination
                    v-model="pageIndex"
                    :pageSize="pageSize"
                    :total="totalRow"
                    :hideOnSinglePage="true"
                    show-less-items
                    @change="pageChange"
                />
            </div>

            <agent-form
                ref="agentForm"
                :visible="formVisible"
                :loading="formLoading"
                :model="formModel"
                @cancel="formCancel"
                @ok="formOk"
            />

            <reset-password
                ref="passwordForm"
                :id="resetPasswordId"
                :visible="resetPasswordVisible"
                :loading="resetPasswordLoading"
                @cancel="resetPasswordVisible = false"
                @ok="resetPasswordOk"
            />
        </a-card>

        <a-modal
            :visible="googleVisible"
            title="绑定谷歌验证"
            :confirmLoading="googleLoading"
            @cancel="closeGoogleModal"
            @ok="confirmGoogleBind"
        >
            <div class="qrcode-box">
                <img class="qrcode" width="300" height="300" :src="qrcode" alt="谷歌验证二维码" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import AgentForm from './AgentForm';
import ResetPassword from './ResetPassword';
import {
    agentList,
    agentAdd,
    agentUpdate,
    agentSetEnable,
    agentResetPassword,
    agentBindGoogleAuth,
    agentBindGoogleAuthPro,
    agentUnbindGoogleAuth
} from '@/api/member/agent';

const tableColumns = [
    { title: '姓名', dataIndex: 'username' },
    { title: '#', dataIndex: 'id', width: 70 },
    { title: '账号', dataIndex: 'loginAccount' },
    { title: '地区', dataIndex: 'areaName' },
    { title: '谷歌验证', scopedSlots: { customRender: 'google' } },
    { title: '状态', scopedSlots: { customRender: 'status' } },
    { title: '创建时间', dataIndex: 'created' },
    { title: '操作', scopedSlots: { customRender: 'action' }, width: 160 }
];

export default {
    name: 'AgentList',
    components: {
        AgentForm,
        ResetPassword
    },
    data() {
        return {
            tableColumns,
            tableData: [],
            tableLoading: false,
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            formVisible: false,
            formLoading: false,
            formModel: null,
            resetPasswordId: 0,
            resetPasswordVisible: false,
            resetPasswordLoading: false,
            googleVisible: false,
            googleLoading: false,
            googleAgentId: 0,
            googleSecret: '',
            qrcode: ''
        };
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            agentList({ page: this.pageIndex, pageSize: this.pageSize }).then(res => {
                this.tableData = res.data.recordList;
                this.totalRow = res.data.totalRow;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.pageIndex = page;
            this.fetchTableData();
        },
        add() {
            this.formModel = null;
            this.formVisible = true;
        },
        update(record) {
            const rest = { ...record };
            delete rest.children;
            this.formModel = rest;
            this.formVisible = true;
        },
        formCancel() {
            this.formVisible = false;
            this.formModel = null;
        },
        formOk() {
            const component = this.$refs.agentForm;
            component.$refs.agentForm.validate(valid => {
                if (!valid) {
                    return;
                }
                const values = { ...component.form };
                const path = (values.areaPath || []).map(Number).filter(n => n > 0);
                // 必须用级联最终选中的地区，避免 areaId 丢失导致 pid 算不出来
                values.areaId = path.length ? path[path.length - 1] : values.areaId;
                values.provinceId = path.length >= 2 ? path[0] : 0;
                delete values.areaPath;
                this.formLoading = true;
                const request = values.id > 0 ? agentUpdate(values) : agentAdd(values);
                request.then(() => {
                    this.formVisible = false;
                    this.formLoading = false;
                    this.formModel = null;
                    this.fetchTableData();
                    this.$message.success(values.id > 0 ? '修改代理成功' : '新增代理成功');
                }).catch(() => {
                    this.formLoading = false;
                });
            });
        },
        handleMore({ key }, record) {
            if (key === 'resetPassword') {
                this.resetPasswordId = record.id;
                this.resetPasswordVisible = true;
                return;
            }
            if (key === 'toggleEnable') {
                this.confirmToggleEnable(record);
                return;
            }
            if (record.googleBound) {
                this.confirmGoogleUnbind(record);
            } else {
                this.openGoogleBind(record);
            }
        },
        resetPasswordOk() {
            const component = this.$refs.passwordForm;
            component.$refs.passwordForm.validate(valid => {
                if (!valid) {
                    return;
                }
                this.resetPasswordLoading = true;
                agentResetPassword({ ...component.form }).then(() => {
                    this.resetPasswordVisible = false;
                    this.resetPasswordLoading = false;
                    this.$message.success('重置密码成功');
                }).catch(() => {
                    this.resetPasswordLoading = false;
                });
            });
        },
        confirmToggleEnable(record) {
            const isEnable = record.isEnable === 'Y' ? 'N' : 'Y';
            const action = isEnable === 'Y' ? '启用' : '停用';
            this.$confirm({
                title: `确定要${action}代理“${record.username}”吗？`,
                onOk: () => agentSetEnable(record.id, isEnable).then(() => {
                    this.fetchTableData();
                    this.$message.success(`${action}成功`);
                })
            });
        },
        openGoogleBind(record) {
            agentBindGoogleAuth(record.id).then(res => {
                this.googleAgentId = record.id;
                this.googleSecret = res.data.secret;
                this.qrcode = res.data.qrcode;
                this.googleVisible = true;
            });
        },
        confirmGoogleBind() {
            this.googleLoading = true;
            agentBindGoogleAuthPro({
                id: this.googleAgentId,
                secret: this.googleSecret
            }).then(() => {
                this.googleLoading = false;
                this.closeGoogleModal();
                this.fetchTableData();
                this.$message.success('绑定成功');
            }).catch(() => {
                this.googleLoading = false;
            });
        },
        closeGoogleModal() {
            this.googleVisible = false;
            this.googleAgentId = 0;
            this.googleSecret = '';
            this.qrcode = '';
        },
        confirmGoogleUnbind(record) {
            this.$confirm({
                title: `确定要解绑代理“${record.username}”的谷歌验证吗？`,
                onOk: () => agentUnbindGoogleAuth(record.id).then(() => {
                    this.fetchTableData();
                    this.$message.success('解绑成功');
                })
            });
        }
    }
};
</script>

<style scoped lang="less">
.qrcode-box {
    display: flex;
    justify-content: center;
}
</style>